<template>
  <div class="p-2 bgCommon">
    <modal-deposit-detail-record :recordDetailsData="recordDetailsData" />

    <!-- Table Top -->

    <div
      class="d-flex flex-wrap mt-2 mb-1 align-items-center justify-content-between"
    >
      <div class="d-flex align-items-center">
        <div>
          <span class="title-size text-nowrap">充值記錄</span>
        </div>
        <!-- <h3 class="font-weight-bolder text-nowrap mb-0">
              <feather-icon size="18" style="margin-top:-3px"  icon="DollarSignIcon" />
              充值記錄
            </h3> -->
        <div class="form-col-select ml-2">
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block"
          />
          <feather-icon size="18" icon="ChevronDownIcon" />
        </div>
      </div>
      <div class="d-flex align-items-center mobile-w100 mt-1 mt-sm-0">
        <div class="search-primary">
          <feather-icon size="16" icon="SearchIcon" />
          <b-form-input
            v-model="searchQuery"
            class="d-inline-block mr-1"
            placeholder="搜尋交易編號或買家姓名"
          />
        </div>
      </div>
    </div>
    <b-card no-body class="mb-0">
      <b-card-body class="p-2">
        <b-table
          ref="refRecordListTable"
          class="position-relative"
          :items="fetchRecords"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: transaction_id -->
          <template #cell(transaction_id)="data">
            <a
              class=""
              href="javascript:void(0)"
              @click="triggerDetailModal(data.item)"
            >
              {{ data.item.transaction_id }}
            </a>
          </template>
          <!-- Column: create time -->
          <template #cell(created_at)="data">
            {{ getCorrectDateTime(data.item.created_at) }}
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRecords"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useRecordsList from "./useRecordsList";
import paymentStoreModule from "../paymentStoreModule";
import ModalDepositDetailRecord from "../modal/ModalDepositDetailRecord.vue";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ModalDepositDetailRecord,
  },
  methods: {
    triggerDetailModal(item) {
      this.recordDetailsData = item;
      this.$root.$emit(
        "bv::show::modal",
        "modal-deposit-detail-record",
        "#btnShow"
      );
    },
  },
  data() {
    return {
      recordDetailsData: {},
    };
  },
  setup() {
    const PAYMENT_APP_STORE_MODULE_NAME = "app-payment";

    // Register module
    if (!store.hasModule(PAYMENT_APP_STORE_MODULE_NAME))
      store.registerModule(PAYMENT_APP_STORE_MODULE_NAME, paymentStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PAYMENT_APP_STORE_MODULE_NAME))
        store.unregisterModule(PAYMENT_APP_STORE_MODULE_NAME);
    });
    const {
      fetchRecords,
      tableColumns,
      perPage,
      currentPage,
      totalRecords,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRecordListTable,
      refetchData,
      ability,
    } = useRecordsList();

    return {
      // Sidebar
      fetchRecords,
      tableColumns,
      perPage,
      currentPage,
      totalRecords,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRecordListTable,
      refetchData,
      ability,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.search-primary {
  width: 100%;
}
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
    